<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isUser()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<!-- main row for all icons  -->
			<div class="col-md-12">
				<div class="form-group">
        	<label>Delivery Partner</label>
        	<v-select v-model="form.dp_id" :options="deliverypartners" label="name" :reduce="deliverypartners => deliverypartners.id" @input="getRest"></v-select>
        </div>
        <div class="form-group">
        	<label>Driver</label>
        	<select class="form-control" v-model="form.driver_id">
        		<option v-for="driver in drivers" :value="driver.id">{{driver.lead_profile.name}}</option>
        	</select>  
        </div>
        <div class="form-group">
        	<label>Vehicle</label>
        	<select class="form-control" v-model="form.vehicle_id">
        		<option v-for="vehicle in vehicles" :value="vehicle.id">{{vehicle.make}}, {{vehicle.model}}, {{vehicle.color}}, {{vehicle.reg_no}}</option>
        	</select>  
        </div>
        <div class="form-group">
        	<label>Start Date</label>
					<input type="date" class="form-control" v-model="form.start_date">
				</div>
				<div class="form-group">
        	<label>End Date</label>
					<input type="date" class="form-control" v-model="form.end_date">
				</div>
				<div class="form-group">
        	<label>Notes</label>
					<input type="text" class="form-control" v-model="form.notes">
				</div>
				<div class="form-group">
					<button class="btn btn-primary" @click="makeTrip">Create</button>
				</div>
			</div>
<!-- row end -->
    </section>
    <!-- /.content -->


    
<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isUser()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getDeliveryPartners();
        },
        
        data(){
        	return{
        		deliverypartners: [],
            drivers: [],
            vehicles: [],
            form: new Form({
            	vehicle_id: '',
            	driver_id: '',
            	dp_id: '',
            	notes: '',
            	start_date: '',
            	end_date: ''
            }),
            errors: []
        	}
        },
        
        methods: {
        	getDeliveryPartners(){
        		axios.post("/api/getAllDeliveryPartners")
        		.then(response => {
        			this.deliverypartners = response.data;
        		})
        	},
        	
        	getRest(){
        		axios.post("/api/getPartnerDrivers", {dp: this.form.dp_id, paginate: false})
        		.then(response => {
        			this.drivers = response.data;
        		})
        		axios.post("/api/getPartnerVehicles", {dp: this.form.dp_id, paginate: false})
        		.then(response => {
        			this.vehicles = response.data;
        		})
        	},
        	
        	makeTrip(){
        		this.form.post("/api/makeDeliveryTrip")
        		.then(response => {
        			toast.fire({
        				icon: 'success',
        				title: 'Trip Created'
        			});
        			this.$router.push('/delivery-trip/'+response.data.id);
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	}
        }
    }
</script>
